import { Button } from '@cokitchen/cokitchen-components';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className='text-center font-semibold text-xl animate-bounce mt-20'>
        ⛔ Access Denied: You don’t have permission to view this page.
      </div>
      <div className='mt-10 flex justify-center '>
        <Button onClick={() => navigate(-1)} color='primary' variant='outline'>
          Go back
        </Button>
      </div>
    </>
  );
};

export default AccessDenied;
